import React, { useEffect, useState } from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { PrismicRichText } from "@prismicio/react";
import { QHFacebookShareButton } from "../common/facebook-share-button";
import { QHXShareButton } from "../common/x-share-button";
import { QHLinkedinShareButton } from "../common/linkedin-share-button";
import ScriptInjector from "../script-injector";

export const Ungated = (props) => {
  const sc = props.slice.primary;

  const co = props.context.data;

  const url = "https://quantum-health.com" + props.context.url + "/";

  const components = {
    label: ({ children }) => <sup>{children}</sup>,
  };

  const getInitialState = () => {
    if (typeof window !== "undefined") {
      const hash = window.location.hash;
      const titleMatch = hash.match(/\btitle=([^&]*)\b/);
  
      return {
        pageTitle: titleMatch ? decodeURIComponent(titleMatch[1]) : sc.resource_title?.text,
      };
    }
  
    // Default state for SSR
    return {
      pageTitle: sc.resource_title?.text,
    };
  };
  
  // State initialization
  const [{ pageTitle }, setPageState] = useState(getInitialState);
  
  useEffect(() => {
    const parseHashParams = () => {
      const hash = window.location.hash;
      const titleMatch = hash.match(/\btitle=([^&]*)\b/);
  
      setPageState((prevState) => {
        const newTitle = titleMatch ? decodeURIComponent(titleMatch[1]) : prevState.pageTitle;
  
        // Update only if values have changed
        if (newTitle !== prevState.pageTitle || newContent !== prevState.pageContent) {
          document.title = newTitle; // Update page title if necessary
          return { pageTitle: newTitle };
        }
  
        return prevState; // No state update if nothing changed
      });
    };
  
    window.addEventListener("hashchange", parseHashParams);
  
    return () => {
      window.removeEventListener("hashchange", parseHashParams);
    };
  }, []);

  return (
    <>
      <section
        className={
          "relative gutter top bg-gradient-to-t from-grey-light to-white"
        }
      >
        <svg
          id="visual"
          viewBox="0 0 960 540"
          preserveAspectRatio="none"
          className="absolute w-full -bottom-px"
          width="100%"
          height="540"
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
        >
          <path
            d="M0 421L40 435.7C80 450.3 160 479.7 240 474.5C320 469.3 400 429.7 480 416.5C560 403.3 640 416.7 720 410.3C800 404 880 378 920 365L960 352L960 541L920 541C880 541 800 541 720 541C640 541 560 541 480 541C400 541 320 541 240 541C160 541 80 541 40 541L0 541Z"
            fill="#fff"
            strokeLinecap="round"
            strokeLinejoin="miter"
          ></path>
        </svg>

        <div className="banner wrapper flex flex-col md:flex-row justify-between items-center md:pt-8 gap-12 md:gap-24">
          <div className="w-full pt-8 md:w-2/4 text-grey">
            {/* If the content is plain text (e.g., from URL hash), render as text */}
            <h1>
                {co.resource_label && (
                <div className={"label bg-opacity-10 uppercase tracking-widest text-xs mb-1 md:mb-2 font-sans font-bold text-" + sc.theme}>{co.resource_label}&nbsp;</div>
              )}
                {pageTitle || co.resource_title.text}
            </h1>
            <div className="soci md:mb-12">
              <p>SHARE</p>
              <QHFacebookShareButton url={url} />
              <QHXShareButton url={url} />
              <QHLinkedinShareButton url={url} />
            </div>
          </div>
          <div className="relative md:top-6 mb-6 w-full md:mb-0 md:w-2/4 flex self-end">
            <GatsbyImage
              loading="eager"
              image={getImage(co.meta_image)}
              className="rounded-3xl md:rounded-t-3xl md:rounded-b-none shadow-2xl md:shadow-none self-end"
              alt={co.resource_title.text}
            />
          </div>
        </div>
      </section>
      <section className="gutter top">
        <div className="wrapper flex flex-col md:flex-row gap-12 md:gap-24">
          <div className="w-full article md:w-2/4">
            <PrismicRichText
              field={sc.content.richText}
              components={components}
            />
            <ScriptInjector html={sc.custom} />
          </div>
          <div className="w-full md:w-2/4 p-12 -mt-12 rounded-3xl shadow-xl self-start text-center">
            <p className="text-4xl font-bold text-grey-md">
              <i className="fa-regular fa-file-pdf" />
            </p>
            <p className="text-2xl font-bold text-teal">
              Get the {sc.type_of_content}
            </p>
            <a
              href={sc.button_link.url}
              className="btn bg-yellow text-lg pr-8 pl-5 ungated"
              target="_blank"
              rel="noreferrer"
            >
              {sc.button_label}
            </a>
          </div>
        </div>
      </section>
    </>
  );
};
